var exports = {
  "xn": "EmbedYouTube.module__thumbnail___dW1tTU",
  "SK": "EmbedYouTube.module__thumbnailPlaceholder___dW1tTU",
  "Lw": "EmbedYouTube.module__overlay___dW1tTU",
  "lW": "EmbedYouTube.module__posterImage___dW1tTU",
  "_y": "EmbedYouTube.module__thumbnailClickTarget___dW1tTU",
  "gO": "EmbedYouTube.module__controlsContainer___dW1tTU",
  "GC": "EmbedYouTube.module__buttonGroup___dW1tTU",
  "kL": "EmbedYouTube.module__container___dW1tTU",
  "j": "EmbedYouTube.module__videoContainer___dW1tTU",
  "pU": "EmbedYouTube.module__iframe___dW1tTU",
};

module.exports = exports;
